import initGallery from './components/gallery';
import initGalleryOverlay from './components/gallery-overlay';

const gallery = document.querySelector('.js-gallery');

if (gallery) {
    initGallery(gallery);
}

const galleryOverlay = document.querySelector('.js-gallery-overlay');

if (galleryOverlay) {
    initGalleryOverlay(galleryOverlay);
}
